import PaymentUnSuccess from "../../../jsx/pages/PaymentUnSuccess";

const PaymentUnSuccessWrapper = function () {
  return <PaymentUnSuccess />;
};

export default constore(PaymentUnSuccessWrapper);
